import { Routes } from '@angular/router';
import { AuthGuard } from './route-guards/redirect.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/home/home.component').then((m) => m.HomeComponent),
    data: {
      seo: {
        title: 'Nexchat AI Agent | WhatsApp API, CRM, Broadcast & Instagram Automation',
        description: 'Scale your business with Nexchat: Official WhatsApp Business Cloud API, high-volume bulk broadcast campaigns, lead CRM with Justdial & portal connectors, abandoned customer recovery, and Instagram DM automation.',
        keywords: 'WhatsApp marketing software, official WhatsApp Business API provider, WhatsApp blast software, WhatsApp chatbot builder, bulk WhatsApp sender without ban, WhatsApp API, WhatsApp bulk broadcast, send bulk WhatsApp messages, WhatsApp campaigns, WhatsApp CRM, Justdial connector, MagicBricks connector, 99acres connector, Facebook lead ads CRM, ManyChat alternative, Instagram automation, customer recovery, abandoned cart WhatsApp, lead management CRM',
        canonicalPath: '/',
        robots: 'index, follow',
        jsonLdSchema: [
          {
            '@context': 'https://schema.org',
            '@type': 'SoftwareApplication',
            'name': 'Nexchat AI Agent',
            'applicationCategory': 'BusinessApplication',
            'operatingSystem': 'All (Web & Cloud)',
            'description': 'AI-driven WhatsApp marketing, bulk broadcast messaging, omni-channel sales CRM, and Instagram automation platform.'
          },
          {
            '@context': 'https://schema.org',
            '@type': 'Organization',
            'name': 'Nexchat AI Agent',
            'url': 'https://thenexchat.com',
            'logo': 'https://ai.myshopyglam.com/assets/icon/download%20(2)-Photoroom.png'
          }
        ]
      }
    }
  },
  {
    path: 'instagram-automation',
    loadComponent: () =>
      import('./pages/nexchat-website/nexchat-website.component').then(
        (m) => m.NexChatWebsiteComponent
      ),
    data: {
      seo: {
        title: 'Instagram Automation & ManyChat Alternative | NexChat AI Sales Agent',
        description: 'Automate Instagram comments to DM, auto-reply to Reels, capture buyer leads, and close sales automatically with NexChat — the creator & brand ManyChat alternative.',
        keywords: 'Instagram automation, ManyChat alternative, comment to DM, Instagram chatbot, auto reply Instagram comments, Instagram Reels lead capture, Instagram DM sales agent, creator sales platform',
        canonicalPath: '/instagram-automation',
        robots: 'index, follow',
        jsonLdSchema: {
          '@context': 'https://schema.org',
          '@type': 'Service',
          'name': 'Instagram Automation & DM Sales AI',
          'serviceType': 'Instagram Marketing Automation',
          'description': 'Automated comment-to-DM triggers, story mentions, and conversational AI checkout for Instagram.',
          'url': 'https://thenexchat.com/instagram-automation',
          'provider': {
            '@type': 'Organization',
            'name': 'Nexchat AI Agent',
            'url': 'https://thenexchat.com'
          }
        }
      }
    }
  },
  {
    path: 'whatsapp-api',
    loadComponent: () =>
      import('./pages/whatsapp-api/whatsapp-api.component').then(
        (m) => m.WhatsAppApiServiceComponent
      ),
    data: {
      seo: {
        title: 'WhatsApp Business Cloud API, Bulk Broadcast & Campaigns | NexChat',
        description: 'Official WhatsApp Business Cloud API with Green Tick verification, high-volume bulk broadcast messaging, abandoned customer recovery, and product catalog selling at affordable pricing.',
        keywords: 'WhatsApp marketing software, official WhatsApp Business API provider, WhatsApp blast software, WhatsApp chatbot builder, bulk WhatsApp sender without ban, WhatsApp API, WhatsApp Business Cloud API, WhatsApp bulk broadcast, send bulk WhatsApp messages, WhatsApp campaigns, WhatsApp bulk messaging software, affordable WhatsApp API, WhatsApp green tick verification, WhatsApp autoresponder, recover old customers WhatsApp, abandoned cart WhatsApp recovery',
        canonicalPath: '/whatsapp-api',
        robots: 'index, follow',
        jsonLdSchema: {
          '@context': 'https://schema.org',
          '@type': 'Service',
          'name': 'WhatsApp Business Cloud API & Bulk Broadcast Platform',
          'serviceType': 'WhatsApp API & Messaging',
          'description': 'Official Meta WhatsApp Cloud API with multi-agent team inbox, bulk promotional broadcasts, and automated customer recovery.',
          'url': 'https://thenexchat.com/whatsapp-api',
          'provider': {
            '@type': 'Organization',
            'name': 'Nexchat AI Agent',
            'url': 'https://thenexchat.com'
          }
        }
      }
    }
  },
  {
    path: 'crm',
    loadComponent: () =>
      import('./pages/crm/crm.component').then(
        (m) => m.CrmServiceComponent
      ),
    data: {
      seo: {
        title: 'WhatsApp AI CRM & Lead Management Pipeline | Justdial & Portal Connector',
        description: 'Auto-capture leads from Justdial, MagicBricks, 99acres, and Meta Facebook Lead Forms. Instantly message leads on WhatsApp and track sales in a visual Kanban CRM pipeline.',
        keywords: 'WhatsApp CRM, AI CRM, lead connectors, Justdial connector CRM, MagicBricks lead connector, 99acres connector CRM, Facebook lead ads CRM, Meta lead forms connector, website lead webhook connector, automatic WhatsApp instant message, sales lead manager, sales pipeline CRM, lead tracking software, lead distribution system',
        canonicalPath: '/crm',
        robots: 'index, follow',
        jsonLdSchema: {
          '@context': 'https://schema.org',
          '@type': 'SoftwareApplication',
          'name': 'Nexchat AI Lead CRM & Pipeline',
          'applicationCategory': 'BusinessApplication',
          'operatingSystem': 'All (Web & Cloud)',
          'description': 'WhatsApp AI CRM with automated portal connectors (Justdial, MagicBricks, 99acres, Facebook Ads), instant WhatsApp auto-dispatch, and visual Kanban sales tracking.',
          'url': 'https://thenexchat.com/crm'
        }
      }
    }
  },
  {
    path: 'signup',
    loadComponent: () =>
      import('./pages/signUp/sign-up.component').then((m) => m.SignUpComponent),
    data: {
      seo: {
        title: 'Get Started Free | Sign Up | Nexchat AI',
        description: 'Create your free Nexchat AI Agent account today to automate WhatsApp campaigns, lead CRM, and Instagram chats.',
        canonicalPath: '/signup',
        robots: 'noindex, follow'
      }
    }
  },
  {
    path: 'signin',
    loadComponent: () =>
      import('./pages/signIn/sign-in.component').then((m) => m.SignInComponent),
    data: {
      seo: {
        title: 'Sign In | Nexchat AI Dashboard',
        description: 'Sign in to your Nexchat AI Agent account to access your WhatsApp broadcasts, lead pipeline CRM, and automated conversations.',
        canonicalPath: '/signin',
        robots: 'noindex, follow'
      }
    }
  },

  {
    path: 'contact',
    loadComponent: () =>
      import('./component/contact/contact.component').then(
        (m) => m.ContactComponent
      ),
    data: {
      seo: {
        title: 'Contact Us | Nexchat AI Support & Enterprise Sales',
        description: 'Speak with our AI automation specialists. Get assistance with WhatsApp Cloud API onboarding, CRM connectors, or custom plan pricing.',
        keywords: 'Nexchat contact, WhatsApp API support, AI CRM demo, Nexchat sales team',
        canonicalPath: '/contact',
        robots: 'index, follow'
      }
    }
  },
  {
    path: 'faq',
    loadComponent: () =>
      import('./component/faq/faq.component').then((m) => m.FAQComponent),
    data: {
      seo: {
        title: 'Frequently Asked Questions (FAQ) | Nexchat AI',
        description: 'Answers to top questions regarding WhatsApp Business Cloud API setup, bulk broadcast safety, Justdial/portal lead sync, pricing, and Instagram automation.',
        keywords: 'WhatsApp API FAQ, bulk broadcast FAQ, Nexchat pricing FAQ, CRM connector help, ManyChat alternative questions',
        canonicalPath: '/faq',
        robots: 'index, follow'
      }
    }
  },
  {
    path: 'terms-of-service',
    loadComponent: () =>
      import('./shared/terms-of-service/terms-of-service.component').then(
        (m) => m.TermsOfServiceComponent
      ),
    data: {
      seo: {
        title: 'Terms of Service | Nexchat AI Agent',
        description: 'Read the Terms of Service for using Nexchat AI Agent software, WhatsApp API integrations, and CRM tools.',
        canonicalPath: '/terms-of-service',
        robots: 'index, follow'
      }
    }
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./shared/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
    data: {
      seo: {
        title: 'Privacy Policy | Nexchat AI Agent',
        description: 'Understand how Nexchat AI Agent securely handles, encrypts, and protects your customer data and WhatsApp conversations.',
        canonicalPath: '/privacy-policy',
        robots: 'index, follow'
      }
    }
  },
  {
    path: 'data-rights',
    loadComponent: () =>
      import('./shared/data-rights/data-rights.component').then(
        (m) => m.DataRightsComponent
      ),
    data: {
      seo: {
        title: 'Exercise Your Data Rights | Nexchat AI',
        description: 'Submit requests for data access, correction, erasure, or consent withdrawal under data protection regulations.',
        canonicalPath: '/data-rights',
        robots: 'noindex, follow'
      }
    }
  },
  {
    path: 'refund-policy',
    loadComponent: () =>
      import('./shared/refund-policy/refund-policy.component').then(
        (m) => m.RefundPolicyComponent
      ),
    data: {
      seo: {
        title: 'Refund Policy | Nexchat AI Subscriptions',
        description: 'Review our refund guidelines, trial periods, and billing policies for Nexchat AI Agent subscription plans.',
        canonicalPath: '/refund-policy',
        robots: 'index, follow'
      }
    }
  },
  {
    path: 'ai-agent-use-cases',
    loadComponent: () =>
      import('./component/ai-agents-case/ai-agents-case.component').then(
        (m) => m.AiAgentsCaseComponent
      ),
    data: {
      seo: {
        title: 'AI Agent & Real Estate Automation Use Cases | Justdial & 99acres Sync | Nexchat',
        description: 'Discover how Real Estate brokers, agencies, and businesses automate Justdial, MagicBricks, and 99acres leads with instant WhatsApp brochures and AI qualifying agents.',
        keywords: 'AI agent use cases, WhatsApp real estate bot, MagicBricks lead connector, 99acres WhatsApp automation, Justdial lead connector, auto send WhatsApp brochure, real estate CRM with 99acres, ecommerce WhatsApp abandoned cart, healthcare lead management',
        canonicalPath: '/ai-agent-use-cases',
        robots: 'index, follow'
      }
    }
  },
  {
    path: 'organizations/create',
    loadComponent: () =>
      import(
        './admin/organizations/create-organization/create-organization.component'
      ).then((m) => m.CreateOrganizationComponent),
    data: {
      seo: {
        title: 'Create Organization',
        robots: 'noindex, nofollow'
      }
    }
  },
  {
    path: 'onboarding',
    loadComponent: () =>
      import('./pages/onboarding/onboarding-wizard.component').then(
        (m) => m.OnboardingWizardComponent
      ),
    canActivate: [AuthGuard],
    data: {
      seo: {
        title: 'Account Onboarding',
        robots: 'noindex, nofollow'
      }
    }
  },
  // ✅ USER AREA
  {
    path: 'user',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./user/user.routes').then(m => m.USER_ROUTES),
    data: {
      seo: {
        title: 'User Portal | Dashboard',
        robots: 'noindex, nofollow'
      }
    }
  },
    {
    path: 'product-catalogs',
    loadComponent: () => import('../app/user/product-catalogs/product-catalogs.component').then(m => m.ProductCatalogsComponent),
    data: {
      seo: {
        title: 'Product Catalogs | Nexchat',
        description: 'Manage and browse product catalogs.',
        robots: 'noindex, nofollow'
      }
    }
  },
  {
    path: 'catalogue',
    loadComponent: () => import('../app/user/product-catalogs/product-catalogs.component').then(m => m.ProductCatalogsComponent),
    data: {
      seo: {
        title: 'Digital Catalogue | Nexchat',
        description: 'View digital product catalogue.',
        robots: 'noindex, nofollow'
      }
    }
  },

  // ✅ ADMIN AREA
  {
    path: 'admin',
    loadComponent: () =>
      import('./user/user.component').then((m) => m.UserComponent),
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
    data: {
      seo: {
        title: 'Admin Portal | Dashboard',
        robots: 'noindex, nofollow'
      }
    }
  },

  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
    data: {
      seo: {
        title: '404 - Page Not Found',
        description: 'The requested page could not be found.',
        robots: 'noindex, nofollow'
      }
    }
  },
];
